import script from "./Deposit.vue?vue&type=script&setup=true&lang=js"
export * from "./Deposit.vue?vue&type=script&setup=true&lang=js"

import "./Deposit.vue?vue&type=style&index=0&id=92c764ba&scoped=true&lang=less"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92c764ba"]])

export default __exports__